import { useState } from 'react';
import SnGModalForm from './components/SnGModalForm';
import SnGsTable from './components/SnGsTable';
import StandardLayout from '@/common/layouts/StandardLayout';
import { FaPlus } from 'react-icons/fa';
import { Button } from 'reactstrap';

const SnGsPage = () => {
  const [formOpen, setFormOpen] = useState(false);

  const openForm = () => setFormOpen(true);
  const closeForm = () => setFormOpen(false);

  return (
    <StandardLayout
      pageTitle="Sit & Go List"
      headerButton={
        <Button onClick={openForm} color="primary" className="d-flex align-items-center gap-2">
          <FaPlus />
          <p className="mb-0">Create New Sit & Go</p>
        </Button>
      }
    >
      <SnGsTable />
      {formOpen && <SnGModalForm onClose={closeForm} />}
    </StandardLayout>
  );
};

export default SnGsPage;
